<div id="content" class="extensible">
  @if (navLinks.length > 1) {
    <div class="company-product-detail-toolbar">
      <nav mat-tab-nav-bar [tabPanel]="tabPanel">
        @for (link of navLinks; track link) {
          <a
            mat-tab-link
            [routerLink]="link.link"
            routerLinkActive
            #rla="routerLinkActive"
            [active]="rla.isActive"
            [queryParams]="queryParams"
            >{{ link.label }}
            @if (link.link === './communication' && (has_pending_communication_config() || has_pending_bot_not_member())) {
              <span class="tab-notification-badge">1</span>
            }
            @if ((link.link === './company-product-deploys' || link.link === './status-monitors') && has_pending_bot_not_member()) {
              <span class="tab-notification-badge">1</span>
            }
            @if (link.link === './applications' && has_pending_unconfigured_applications()) {
              <span class="tab-notification-badge">1</span>
            }
          </a>
        }
      </nav>
      @if (is_worker) {
        @if (company_product(); as selected_company_product) {
          <button mat-icon-button [matMenuTriggerFor]="menu" class="company-product-detail-menu small-icon-button">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @if (selected_company_product.wiki_node_id) {
              <button mat-menu-item [routerLink]="['/employees', 'wiki', selected_company_product.wiki_node_id]">
                <mat-icon>import_contacts</mat-icon>
                Documentación
              </button>
            }
            @if (can_download_daily_anonymized_dump()) {
              <button mat-menu-item (click)="downloadDailyAnonymizedDump()">
                <mat-icon>download</mat-icon>
                Descargar dump anonimizado
              </button>
            }
            <button mat-menu-item (click)="openCompanyProductReport()">
              <mat-icon>summarize</mat-icon>
              Informe del producto
            </button>
            <button mat-menu-item (click)="openTimeDistributionCrudDialog()">
              <mat-icon>date_range</mat-icon>
              Tiempo en fases
            </button>
            <button mat-menu-item (click)="startMeetingMode()">
              <mat-icon>screen_share</mat-icon>
              Modo reunión
            </button>
            @if (permissions.validateDepartment(['direction', 'rrhh'])) {
              <button mat-menu-item (click)="openCompanyProductSettings()">
                <mat-icon>settings</mat-icon>
                Configurar producto
              </button>
            }
          </mat-menu>
        }
      }
    </div>
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
  }
  <router-outlet></router-outlet>
</div>
